import * as React from "react";
import {cs} from "../../react/chain-services";
import {css} from "emotion";
import {UseState} from "../../react/use-state";
import {TimeoutAction} from "../../react/timeout-action";
import {fragments} from "../../react/fragments";
import {rgba} from "polished";

export const ErrorHighlighter = ({next}) => cs(
    ["highlightingErrors", (_, next) => UseState({next})],
    ({highlightingErrors}) => fragments(
        next({
            start: () => {
                highlightingErrors.onChange(true);
            },
            css: highlightingErrors.value && css1 || undefined,
        }),
        highlightingErrors.value && (
            TimeoutAction({
                delay: 2100,
                action: () => highlightingErrors.onChange(false),
            })
        ),
    ),
);


const css1 = css`
  @keyframes bg-2tt {
    0% {
      box-shadow: 0 0 13px ${rgba("red", 0)};
    }
    40% {
      box-shadow: 0 0 20px ${rgba("red", 0.8)};
    }
    95% {
      box-shadow: 0 0 13px ${rgba("red", 0)};
    }
  }
  animation-name: bg-2tt;
  animation-duration: 1s;
  animation-iteration-count: 2;
  animation-timing-function: ease;
`;
